<div style="display:inline-block" class="item-thumbnail" (click)="onClick(dialogViewer, $event)">
    <div *ngIf="!item && placeholder" class="item-thumbnail-placeholder" [ngStyle]="{width:phSize, height:phSize}">
    </div>
    <img *ngIf="item" class="item-thumbnail-image" [src]="item.ProductImageURL()"
        [ngStyle]="{width:pxSize, height:pxSize}" />
</div>

<ng-template #dialogViewer>
    <img *ngIf="item" [src]="item.ProductImageURL(90, this.innerWidth)" (click)="dialogRef.close()" />
</ng-template>